import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContainedButtonVariant } from '../Buttons/ContainedButton'
import { TextButtonVariant } from '../Buttons/TextButton'
import ConfirmWithButtonsModal from './ConfirmWithButtonsModal'

interface TranscriptConfirmClearModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

const TranscriptConfirmClearModal: React.FC<
  TranscriptConfirmClearModalProps
> = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation()
  return (
    <ConfirmWithButtonsModal
      isOpen={isOpen}
      title={t(
        'Transcript.TranscriptFormCard.DeleteModal.Title',
        'Clear Classes'
      )}
      question={t(
        'Transcript.TranscriptFormCard.DeleteModal.Question',
        'Are you sure you want to clear all class information?'
      )}
      questionProps={{ variant: 'body1', align: 'center' }}
      confirmVariant={ContainedButtonVariant.YesProceed}
      cancelVariant={TextButtonVariant.NoCancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}

export default TranscriptConfirmClearModal
